import React, { createContext, useState, useEffect } from "react"
const SidebarContext = createContext()

export const PAYMENT_FILTERS_INITIAL = {
  applicationId: "",
  partnerId: "",
  studentName: "",
  currentYear: "",
  currentSemester: "",
  isPaid: "",
  amountComitted: "",
  amountPaid: "",
  paymentDueDate: "",
  paymentMadeDate: "",
  challanNumber: "",
  paymentMode: "",
  notes: "",
  country: "",
  sortBy: "",
  asce: "",
}

export const SidebarProvider = ({ children }) => {
  const [savedCurrentPage, setSavedCurrentPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [applicationFilters, setApplicationFilters] = useState({
    status: "All",
  })
  const [filters, setFilters] = useState({
    role: "",
    isDelete: "false"
  })
  const [paymentFilters, setPaymentFilters] = useState(PAYMENT_FILTERS_INITIAL)
  const [searchStaff, setSearchStaff] = useState('')
  const [applicationCountryFilter, setApplicationCountryFilter] = useState('')
  const [activeStates, setActiveStates] = useState({
    main: "Dashboard",
    child: "",
  })
  const [shouldRefetch, setShouldRefetch] = useState(true);

  useEffect(()=>{
    setCurrentPage(1);
    setShouldRefetch(true);
  }, [applicationFilters?.status])

  useEffect(() => {
    console.log("Active state changed::", activeStates)
    setCurrentPage(1)
    console.log("Active State", activeStates?.main)
    if(activeStates?.main !== "Application List"){
      setSavedCurrentPage(1)
      setSearchStaff("")
      setApplicationCountryFilter("")
      setApplicationFilters((prev)=>({
        ...prev,
        status: "All"
      }))
    }
    if (activeStates?.main !== "Payment Management") {
      setPaymentFilters(PAYMENT_FILTERS_INITIAL)
    }
    setFilters((prev)=>({
      ...prev,
      role: "",
      isDelete: "false"
    }))
  }, [activeStates?.main, activeStates?.child])

  return (
    <SidebarContext.Provider
      value={{
        searchStaff,
        setSearchStaff,
        activeStates,
        setActiveStates,
        currentPage,
        setCurrentPage,
        savedCurrentPage, 
        setSavedCurrentPage,
        itemsPerPage,
        setItemsPerPage,
        applicationFilters,
        setApplicationFilters,
        applicationCountryFilter,
        setApplicationCountryFilter,
        shouldRefetch,
        setShouldRefetch,
        filters,
        setFilters,
        paymentFilters,
        setPaymentFilters,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export default SidebarContext
